/**
 * @param {string | { key?: string; name?: string } | null | undefined} role
 * @param {Map<string, { name?: string }> | Record<string, { name?: string }> | null} [catalog]
 * @returns {string}
 */
export function formatRoleLabel(role, catalog = null) {
  const key = typeof role === 'object' && role !== null ? role.key : role
  const inlineName = typeof role === 'object' && role !== null ? role.name : null
  if (inlineName) return inlineName
  if (catalog && key) {
    const entry = catalog instanceof Map ? catalog.get(key) : catalog[key]
    if (entry?.name) return entry.name
  }
  if (key === 'super_admin') return 'Super Admin'
  if (key === 'admin') return 'Admin'
  if (key === 'user') return 'User'
  if (!key) return 'User'
  return String(key).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}
